import { Atom, WritableAtom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';

const atomRegistry = new Set<Atom<unknown>>();

export function createUserDataAtom<T>(initialValue: T) {
  const atom = atomWithReset(initialValue);
  atomRegistry.add(atom);
  return atom;
}

interface JotaiStore {
  set: <Value, Args extends unknown[], Result>(
    atom: WritableAtom<Value, Args, Result>,
    ...args: Args
  ) => Result;
}

export function resetAllUserDataAtoms(store: JotaiStore) {
  atomRegistry.forEach(atom => {
    // Cast to WritableAtom since atomWithReset creates a writable atom
    store.set(atom as WritableAtom<unknown, [typeof RESET | unknown], void>, RESET);
  });
}

export { atomRegistry };